import { render, staticRenderFns } from "./mall-order-list.vue?vue&type=template&id=2bce0e88&scoped=true"
import script from "./mall-order-list.vue?vue&type=script&lang=js"
export * from "./mall-order-list.vue?vue&type=script&lang=js"
import style0 from "./mall-order-list.vue?vue&type=style&index=0&id=2bce0e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce0e88",
  null
  
)

export default component.exports